/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Label_Approved_ByInputs */

const vi_sinp_label_approved_by = /** @type {(inputs: Sinp_Label_Approved_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người duyệt`)
};

/**

* @param {Sinp_Label_Approved_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_label_approved_by = /** @type {((inputs?: Sinp_Label_Approved_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Label_Approved_ByInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_label_approved_by(inputs)
});